import apiClient from "./apiClient";
import { API_ENDPOINTS } from "./endpoints";

export const login = (credentials) =>
  apiClient.post(API_ENDPOINTS.LOGIN, credentials);

export const signup = (data) => apiClient.post(API_ENDPOINTS.SIGNUP, data);

export const forgot = (credentials) =>
  apiClient.post(API_ENDPOINTS.FORGOT, credentials);

export const logout = (data) =>
  apiClient.post(API_ENDPOINTS.LOGOUT, data, { withAuth: true });

export const changePassword = (data) =>
  apiClient.post(API_ENDPOINTS.CHANGE_PASSWORD, data, { withAuth: true });
